module.exports = __webpack_public_path__ + "static/media/mealIcon.b27ba19e.svg";